import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@munifocus/ui';
import { useTranslation } from 'react-i18next';
import { useOfficerCertifications } from '../../lib/certifications-api';
import { CertificationList } from './CertificationList';

/**
 * One roster member's training certifications, opened from the officers list.
 * Fetched only while open — the roster itself stays one request.
 */
export function OfficerCertificationsDialog({
  localGovernmentId,
  officer,
  onClose,
}: {
  localGovernmentId: string;
  officer: { userId: string; name: string } | null;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const query = useOfficerCertifications(localGovernmentId, officer?.userId ?? null);
  return (
    <Dialog open={Boolean(officer)} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {t('gov.certifications.officerTitle', { name: officer?.name ?? '' })}
      </DialogTitle>
      <DialogContent>
        <CertificationList
          summary={query.data}
          isLoading={query.isLoading}
          isError={query.isError}
          emptyLabel={t('gov.certifications.officerEmpty')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.actions.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
